// extracted by mini-css-extract-plugin
module.exports = {"count":"tags-count_count__-vkDt","rub":"tags-count_rub__135nd","select":"tags-count_select__U70OB","cumul":"tags-count_cumul__15yXu","exclude":"tags-count_exclude__3luHg"};